import ProductSkeleton from "@components/CMS/Skeleton/ProductSkeleton";
import FlatList from "@components/FlatList";
import {
  DISCOVERY_FLOW_EVENTS,
  ORDER_FLOW_EVENTS,
  SHARING_EVENTS,
} from "@constants/analyticsEventsCT";
import colors from "@constants/color";
import { actions as customerActions } from "@reducers/customerReducer";
import CartBottomStrip from "@screens/Home/CartBottomStrip";
import analytics from "@services/analytics";
import { getCMSEntityById } from "@services/cmsV2-api";
import React, { useEffect, useState } from "react";
import { ActivityIndicator, Dimensions, View } from "react-native";
import { connect } from "react-redux";
import { isCLApp } from "../../config";
import { shareOnWhatsapp } from "../../utils/shareEntity";
import VerticalProduct from "../ProductDisplayUnit/VerticalProduct";
import CategoryHeader from "./CategoryHeader";

const { width } = Dimensions.get("window");

const handleShareOnWhatsapp = (
  sharingTemplate,
  sharingLink,
  eventProps = {},
) => {
  const { template, image_link } = sharingTemplate;
  analytics.trackEvent(SHARING_EVENTS.LIST_SHARE, {
    screen_name: "DynamicCMSListing",
    ...eventProps,
  });
  shareOnWhatsapp({
    message: `${template}\n${sharingLink}`,
    image: image_link,
  });
};

const InfiniteFlatListFooter = ({ endOfResults }) => {
  return (
    <View
      style={{
        // justifyContent: "center",
        alignItems: "center",
        // padding: 20,
        padding: 8,
        height: 200,
      }}
    >
      {!endOfResults && (
        <ActivityIndicator color={colors.primary} size="small" />
      )}
    </View>
  );
};

function InfiniteFlatList({
  products = [],
  cms_item_id,
  title_ref,
  navigation,
  user,
  productCount,
  shareSkuTemplates = "",
  selectedContact,
  setSelectedContact,
  cartDetails,
  cartItems,
  cl_title = "",
  cx_title = "",
  sharingTemplate,
  sharingLink,
  trackEvent,
}) {
  const [shouldLoadMore, setShouldLoadMore] = useState(true);
  const [endOfResults, setEndOfResults] = useState(false);
  const [productsState, setProductsState] = useState(products);

  useEffect(() => {
    if (cms_item_id) {
      analytics.trackEvent(DISCOVERY_FLOW_EVENTS.PRODUCT_LIST_VIEWED, {
        cms_item_id,
        cms_list_title: title_ref,
      });
      if (!products || products?.length === 0) {
        // Verify if we get navigation
        navigation.navigate("PageNotFound", {
          cms_item_id,
          title_ref,
        });
        return null;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cms_item_id, title_ref]);

  const loadMore = async () => {
    if (products.length === 0 || !shouldLoadMore) {
      return;
    }
    if (products.length === Number(productCount)) {
      setEndOfResults(true);
      setShouldLoadMore(false);
      return;
    }
    try {
      const { data } = await getCMSEntityById({
        id: cms_item_id,
        offset: products.length,
        user_id: user?.user_id,
      });
      setProductsState((state) => [...state, ...data.products]);
    } catch (e) {
      setEndOfResults(true);
      setShouldLoadMore(false);
      console.log(e);
    }
  };

  const fireSearchEvent = () => {
    analytics.trackEvent(DISCOVERY_FLOW_EVENTS.PRODUCT_SEARCH_ICON, {
      previous_screen: "DynamicCMSListing",
    });
  };

  const InfiniteFlatListItem = ({ index, item }) => {
    const { CL: { template: shareSkuTemplate = "" } = {} } =
      shareSkuTemplates || {};
    const { app_share_app_link } = user;
    const { slug } = item;
    const sharingLink2 = `${app_share_app_link}?app_screen=ProductDetails&slug=${slug}&channel=cl_product_share`;

    return (
      <VerticalProduct
        key={`p${index}`}
        data={item}
        index={index}
        sharingTemplate={shareSkuTemplate}
        trackEvent={trackEvent}
        sharingLink={sharingLink2}
      />
    );
  };

  const ListFooterFunc = () => {
    return (
      <>
        <InfiniteFlatListFooter endOfResults={endOfResults} />
      </>
    );
  };

  const categoryTitle = isCLApp ? cl_title : cx_title;
  const cartItemQty =
    (Array.isArray(cartItems) &&
      cartItems.reduce((acc, curr) => {
        acc += curr.quantity;
        return acc;
      }, 0)) ||
    "";

  return productsState.length >= 1 ? (
    <>
      <CategoryHeader
        title={categoryTitle}
        {...{
          categoryTitle,
          navigation,
          shareOnWhatsapp: () => {
            handleShareOnWhatsapp(sharingTemplate, sharingLink, title_ref);
          },
        }}
        trackEvent={fireSearchEvent}
      />
      <View style={{ height: "100%", width }}>
        <FlatList
          data={productsState}
          renderItem={({ item, index }) => (
            <InfiniteFlatListItem
              item={item}
              index={index}
              trackEvent={trackEvent}
            />
          )}
          keyExtractor={(item, index) => `p${index}`}
          showsVerticalScrollIndicator={false}
          onEndReached={loadMore}
          ListFooterComponent={ListFooterFunc}
        />
      </View>
      {selectedContact && (
        <CartBottomStrip
          bottom={{ bottom: 66 }}
          orderClick={() => {
            navigation.push("ConfirmOrder");
            analytics.trackEvent(ORDER_FLOW_EVENTS.CHECKOUT_STARTED, {
              screen: "SKU_LIST",
              cart_value: cartDetails.total,
              cart_quantity: cartItemQty,
            });
          }}
          onCrossClick={() => {
            setSelectedContact();
            analytics.trackEvent(ORDER_FLOW_EVENTS.CX_CANCELLED);
          }}
          total={cartDetails.total}
          item={cartItems.length}
          name={selectedContact.user_name}
        />
      )}
    </>
  ) : (
    <View>
      <CategoryHeader
        title={categoryTitle}
        {...{
          categoryTitle,
          navigation,
          shareOnWhatsapp: () =>
            handleShareOnWhatsapp(sharingTemplate, sharingLink, title_ref),
        }}
        trackEvent={fireSearchEvent}
      />
      <ProductSkeleton />
      <ProductSkeleton />
      <ProductSkeleton />
      <ProductSkeleton />
      <ProductSkeleton />
    </View>
  );
}

const mstp = ({
  customer: { selectedContact },
  cart: { cartDetails, cartItems },
  auth: { user },
}) => {
  return {
    selectedContact,
    cartDetails,
    cartItems,
    user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSelectedContact: () =>
      dispatch(customerActions.setSelectedContact(false)),
  };
};

export default connect(mstp, mapDispatchToProps)(InfiniteFlatList);
